export default "__VITE_ASSET__CKLMAGyY__"